
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/seller/detail/dead",
      function () {
        return require("private-next-pages/service/seller/detail/dead.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/seller/detail/dead"])
      });
    }
  